{
  "app": {
    "name": "Beyond Silence",
    "tagline": "Journalism that breaks the silence"
  },
  "nav": {
    "home": "Home",
    "articles": "Articles",
    "about": "About",
    "donate": "Donate",
    "language": "Language",
    "menu": "Menu",
    "close": "Close",
    "search": "Search"
  },
  "search": {
    "placeholder": "Search articles…",
    "submit": "Search",
    "clear": "Clear search",
    "inputLabel": "Search articles"
  },
  "actions": {
    "readMore": "Read more",
    "share": "Share",
    "backToHome": "Back to home",
    "loadMore": "Load more"
  },
  "states": {
    "loading": "Loading…",
    "error": "Something went wrong",
    "empty": "Nothing to show yet",
    "notFound": "Page not found",
    "unauthorized": "You do not have access to this page",
    "articleNotFound": "The article you're looking for doesn't exist or has been removed."
  },
  "footer": {
    "copyright": "© {{year}} Beyond Silence. All rights reserved.",
    "legalNotice": "Legal Notice",
    "privacy": "Privacy Policy",
    "terms": "Terms of Use",
    "contact": "Contact",
    "coffee": "Buy us a coffee",
    "builtBy": "Site built by"
  },
  "legal": {
    "legalNotice": {
      "title": "Legal Notice",
      "sections": [
        {
          "h": "Site Publisher",
          "b": "Beyond Silence, a trilingual journalism platform (French, English, Arabic), published by the Beyond Silence team."
        },
        {
          "h": "Design and Development",
          "b": "Webnova — 60 Rue François Ier, 75008 Paris, France. SIRET: 941 713 125 00016."
        },
        {
          "h": "Hosting",
          "b": "This site is hosted by Cloudflare (Cloudflare Pages). For any questions about hosting, please contact the publisher."
        },
        {
          "h": "Intellectual Property",
          "b": "All content on this site (texts, images, graphics, logo, videos) is the exclusive property of Beyond Silence and its contributors. Any reproduction, even partial, is prohibited without prior written consent."
        },
        {
          "h": "Liability",
          "b": "Beyond Silence strives to ensure the accuracy of the information published on this site, but cannot guarantee its completeness. The publisher declines all responsibility for any damage resulting from use of the site."
        },
        {
          "h": "Contact",
          "b": "For any questions regarding these legal notices, you may contact us via the contact page on the site or by email at contact@beyondsilence.fr."
        }
      ]
    },
    "privacy": {
      "title": "Privacy Policy",
      "sections": [
        {
          "h": "1. Information We Collect",
          "b": "We collect only the information needed to run Beyond Silence: technical data such as browser type and pages viewed, and — if you make a donation — the payment details processed by our payment provider. We never see or store your full card number."
        },
        {
          "h": "2. How We Use Your Information",
          "b": "We use this information to operate and improve the site, process donations, and meet legal obligations. Analytics are aggregated and anonymized; we use privacy-safe session identifiers, never raw IP addresses, email addresses, or other stable personal identifiers."
        },
        {
          "h": "3. Cookies and Tracking",
          "b": "We do not run advertising or ad-tracking cookies. Any cookies we use are strictly necessary for site functionality and language preferences."
        },
        {
          "h": "4. Sharing Your Information",
          "b": "We never sell your personal information. Data is shared only with trusted processors (hosting, database, and payment providers) to the extent needed to provide the service, or when required by law."
        },
        {
          "h": "5. Retention and Your Rights",
          "b": "We keep personal data only as long as necessary. You may request access to, correction of, or deletion of your data at any time by contacting us."
        }
      ]
    },
    "terms": {
      "title": "Terms of Use",
      "sections": [
        {
          "h": "1. Acceptance",
          "b": "By using beyondsilence.fr, you agree to these terms. If you do not agree, please do not use the site."
        },
        {
          "h": "2. Content and Intellectual Property",
          "b": "All articles, images, and videos on this site are the property of Beyond Silence and its contributors, unless otherwise stated. You may share links and short quotations with attribution, but not reproduce our content for commercial use without permission."
        },
        {
          "h": "3. Donations",
          "b": "Donations are voluntary contributions processed securely by our payment provider. They are not a purchase and do not create any subscription or entitlement."
        },
        {
          "h": "4. Acceptable Use",
          "b": "You agree not to misuse the site, interfere with its operation, or attempt to access restricted systems or data."
        },
        {
          "h": "5. Disclaimers and Liability",
          "b": "Journalism is provided for general information. While we strive for accuracy, we do not guarantee completeness or timeliness and accept no liability for reliance on our content."
        },
        {
          "h": "6. Changes and Contact",
          "b": "We may update these terms from time to time. Continued use of the site constitutes acceptance. Questions? Contact us at contact@beyondsilence.fr."
        }
      ]
    }
  }
}
